import axios from './axiosInstance';

export const categoriesList = async (params = {}) => {
  const response = await axios.get("/club_api/categories", { params });
  return response.data;
};

export const upsertCategory = async (category) => {
  const query = !category?.id ? axios.post("/club_api/categories", { category }) : axios.put("/club_api/categories/" + category.id, { category });
  const response = await query;
  return response.data;
};

export const removeCategory = async (id) => {
  const response = await axios.delete("/club_api/categories/" + id);
  return response.data;
};
